<template>
	-
<!-- <ul class="social-nav model-3d-0 footer-social w3_agile_social dir-rtl two">
		<li><a href="index.html#" class="facebook">
			<div class="front"><i class="fa fa-facebook" aria-hidden="true"></i></div>
			<div class="back"><i class="fa fa-facebook" aria-hidden="true"></i></div></a>
        </li>
		<li><a href="index.html#" class="twitter">
			<div class="front"><i class="fa fa-twitter" aria-hidden="true"></i></div>
			<div class="back"><i class="fa fa-twitter" aria-hidden="true"></i></div></a>
        </li>
		<li><a href="index.html#" class="instagram">
			<div class="front"><i class="fa fa-instagram" aria-hidden="true"></i></div>
			<div class="back"><i class="fa fa-instagram" aria-hidden="true"></i></div></a>
        </li>
		<li><a href="index.html#" class="pinterest">
			<div class="front"><i class="fa fa-linkedin" aria-hidden="true"></i></div>
			<div class="back"><i class="fa fa-linkedin" aria-hidden="true"></i></div></a>
        </li>
</ul> -->
</template>

<script>
export default {
name:"ShareAbility"
}
</script>

<style>

</style>